module.exports = __webpack_public_path__ + "static/media/wallpaper-3.db0f1cf4.jpg";